var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 606,
    height: 507,
    viewBox: "0 0 606 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2357_2867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.11 4.59979C155.11 4.59979 178.952 11.6113 198.563 30.4724C218.175 49.3335 226.122 72.8732 226.122 72.8732C211.081 88.5218 189.741 78.9101 170.134 60.049C150.527 41.1879 140.341 19.9595 155.11 4.59979Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.125 72.8716C234.433 64.229 225.272 41.9407 205.662 23.0893C186.052 4.23799 163.419 -4.03776 155.111 4.60491C146.803 13.2476 155.965 35.5359 175.575 54.3872C195.184 73.2385 217.817 81.5143 226.125 72.8716Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.657 23.0814L202.69 26.1689",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.814 51.0066L175.847 54.0941",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.567 4.76801L162.575 11.4992",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.929 65.672L225.932 72.4075",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.169 51.5369L219.115 48.9583",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.385 28.2172L155.335 25.6342",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.412 3.70721L179.267 10.654",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.233 66.5215L205.088 73.464",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.955 64.111L221.349 59.027",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.156 18.1441L152.545 13.0601",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.358 11.5164L191.237 16.9065",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.267 60.2646L190.146 65.6548",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.338 75.7753L212.043 68.3714",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.461 8.80411L164.166 1.39594",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.196 37.4968L212.729 37.7124",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.771 39.4588L163.308 39.6787",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16 35.0333C204.252 33.8967 203.048 30.9657 200.469 28.4868C197.89 26.0078 194.914 24.9196 193.821 26.0562C192.729 27.1927 193.934 30.1237 196.512 32.6026C199.091 35.0816 202.067 36.1698 203.16 35.0333Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.911 50.8965C189.004 49.76 187.799 46.829 185.22 44.3501C182.641 41.8711 179.665 40.7829 178.573 41.9194C177.48 43.056 178.685 45.987 181.264 48.4659C183.842 50.9449 186.818 52.0331 187.911 50.8965Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.538 25.6649C178.631 24.5284 177.426 21.5974 174.847 19.1184C172.269 16.6395 169.293 15.5512 168.2 16.6878C167.107 17.8244 168.312 20.7553 170.891 23.2343C173.47 25.7132 176.446 26.8015 177.538 25.6649Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.562 45.8741C200.362 44.001 198.377 39.1712 194.128 35.0863C189.879 31.0015 184.975 29.2085 183.174 31.0816C181.373 32.9547 183.358 37.7846 187.607 41.8694C191.857 45.9542 196.761 47.7472 198.562 45.8741Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.536 60.2679C214.628 59.1314 213.424 56.2004 210.845 53.7215C208.266 51.2425 205.29 50.1543 204.197 51.2908C203.105 52.4274 204.309 55.3583 206.888 57.8373C209.467 60.3163 212.443 61.4045 213.536 60.2679Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.59 222.757H217.092V263.964C217.092 265.783 216.37 267.528 215.083 268.815C213.796 270.101 212.051 270.824 210.232 270.824H206.446C204.626 270.824 202.881 270.101 201.595 268.815C200.308 267.528 199.585 265.783 199.585 263.964V222.757H199.59Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.567 222.762H177.124L179.064 166.894L179.995 140.241C180.244 133.053 183.274 126.243 188.446 121.247C193.619 116.25 200.53 113.458 207.722 113.459H208.964C216.156 113.459 223.067 116.251 228.24 121.247C233.413 126.244 236.445 133.053 236.695 140.241L237.622 166.894L238.601 194.841L239.567 222.762Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.567 222.762H177.119L178.089 194.828H238.592L239.567 222.762Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.592 194.828H178.089L179.064 166.894H237.622L238.592 194.828Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.632 180.852H290.135V263.968C290.135 265.788 289.412 267.533 288.126 268.819C286.839 270.106 285.094 270.829 283.274 270.829H279.488C277.669 270.829 275.924 270.106 274.637 268.819C273.351 267.533 272.628 265.788 272.628 263.968V180.852H272.632Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.343 189.994H362.845V264.011C362.845 265.818 362.128 267.551 360.85 268.829C359.572 270.106 357.839 270.824 356.032 270.824H352.151C350.345 270.824 348.612 270.106 347.334 268.829C346.056 267.551 345.338 265.818 345.338 264.011V189.994H345.343Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.053 140.746H435.556V263.968C435.556 265.788 434.833 267.533 433.547 268.819C432.26 270.106 430.515 270.829 428.695 270.829H424.914C423.094 270.829 421.349 270.106 420.063 268.819C418.776 267.533 418.053 265.788 418.053 263.968V140.746Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.61 180.861H250.162L252.107 124.985L253.034 98.3275C253.285 91.1406 256.317 84.332 261.49 79.3367C266.663 74.3413 273.574 71.5495 280.765 71.5494H282.007C289.198 71.5495 296.108 74.3413 301.281 79.3367C306.455 84.332 309.486 91.1406 309.738 98.3275L310.665 124.985L311.635 152.914L312.61 180.861Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.605 180.861H250.162L251.132 152.927H311.635L312.605 180.861Z",
    fill: "#CAD8E5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.635 152.927H251.132L252.107 124.994H310.665L311.635 152.927Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32 189.998H322.872L324.817 134.131L325.749 107.473C325.998 100.287 329.028 93.4774 334.201 88.4817C339.374 83.486 346.284 80.6943 353.475 80.6953H354.717C361.909 80.6954 368.819 83.4873 373.992 88.4826C379.165 93.478 382.197 100.287 382.448 107.473L383.375 134.131L384.35 162.069L385.32 189.998Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32 189.994H322.872L323.843 162.065H384.346L385.32 189.994Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.346 162.065H323.843L324.817 134.131H383.375L384.346 162.065Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.031 140.746H395.587L397.528 84.8824L398.459 58.225C398.708 51.0382 401.739 44.229 406.912 39.2333C412.084 34.2376 418.995 31.4459 426.186 31.4469H427.428C434.619 31.447 441.529 34.2389 446.703 39.2342C451.876 44.2296 454.907 51.0381 455.159 58.225L456.086 84.8824L457.06 112.816L458.031 140.746Z",
    fill: "#CAD8E5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.031 140.746H395.583L396.553 112.812H457.056L458.031 140.746Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.056 112.812H396.553L397.528 84.8824H456.086L457.056 112.812Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.905 323.341V334.246C169.904 337.209 170.486 340.143 171.619 342.881C172.751 345.618 174.412 348.106 176.507 350.201L176.692 350.382C179.907 353.599 181.714 357.96 181.716 362.508V396.237C181.716 396.92 181.674 397.603 181.591 398.281C181.135 402.096 179.409 405.647 176.692 408.363L163.325 421.73C163.243 421.813 163.146 421.879 163.039 421.924C162.931 421.968 162.816 421.99 162.7 421.989H114.844C114.728 421.99 114.612 421.968 114.505 421.924C114.397 421.879 114.3 421.813 114.219 421.73L100.851 408.363C98.1342 405.647 96.4089 402.096 95.9527 398.281C95.8699 397.603 95.8281 396.92 95.8277 396.237V362.771C95.8273 361.235 96.0273 359.706 96.4227 358.222C96.6231 357.453 96.8766 356.7 97.1817 355.967C98.0765 353.81 99.3896 351.852 101.045 350.206C103.14 348.11 104.801 345.623 105.934 342.885C107.067 340.148 107.649 337.214 107.647 334.251V323.341C107.652 321.238 107.362 319.145 106.785 317.123C106.556 316.305 106.276 315.501 105.948 314.717C104.818 311.976 103.157 309.485 101.063 307.386C97.5063 303.845 95.4984 299.038 95.4784 294.019V269.871C95.477 267.376 95.968 264.904 96.9233 262.598C97.8785 260.293 99.2793 258.198 101.045 256.435L123.55 233.934C125.641 231.84 126.815 229.002 126.814 226.043V213.693C126.814 213.465 126.905 213.245 127.067 213.083C127.229 212.922 127.448 212.831 127.677 212.831H149.841C150.07 212.831 150.289 212.922 150.451 213.083C150.613 213.245 150.703 213.465 150.703 213.693V226.043C150.703 229.002 151.877 231.84 153.968 233.934L174.411 254.348L176.507 256.439C180.065 260.004 182.064 264.835 182.065 269.871V294.019C182.065 296.511 181.574 298.978 180.621 301.281C180.345 301.95 180.03 302.602 179.676 303.234C178.821 304.776 177.754 306.191 176.507 307.438C172.278 311.671 169.903 317.41 169.905 323.393V323.341Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19 192.154H127.349C125.165 192.154 123.395 193.925 123.395 196.108V208.859C123.395 211.043 125.165 212.814 127.349 212.814H150.19C152.374 212.814 154.144 211.043 154.144 208.859V196.108C154.144 193.925 152.374 192.154 150.19 192.154Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.768 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.075 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.279 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.716 363.314V396.242C181.715 396.925 181.674 397.607 181.591 398.285C181.135 402.1 179.409 405.651 176.692 408.367L163.325 421.735C163.243 421.818 163.146 421.883 163.039 421.928C162.931 421.972 162.816 421.995 162.7 421.993H114.844C114.728 421.995 114.612 421.972 114.505 421.928C114.397 421.883 114.3 421.818 114.219 421.735L100.851 408.367C98.1341 405.651 96.4089 402.1 95.9527 398.285C95.8698 397.607 95.8281 396.925 95.8276 396.242V363.314H181.716Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.299 323.341V334.251C259.296 337.214 259.877 340.148 261.01 342.886C262.143 345.624 263.805 348.111 265.901 350.206L266.086 350.391C269.3 353.608 271.105 357.969 271.106 362.517V396.242C271.107 396.926 271.066 397.61 270.985 398.29C270.527 402.104 268.802 405.654 266.086 408.371L252.719 421.739C252.638 421.823 252.541 421.889 252.433 421.934C252.326 421.98 252.21 422.003 252.094 422.002H204.229C204.113 422.003 203.997 421.98 203.89 421.934C203.782 421.889 203.685 421.823 203.604 421.739L190.237 408.371C187.023 405.152 185.215 400.791 185.209 396.242V362.78C185.208 360.444 185.668 358.132 186.561 355.974C187.455 353.816 188.766 351.856 190.418 350.206C192.513 348.111 194.175 345.623 195.307 342.886C196.44 340.148 197.022 337.214 197.02 334.251V323.341C197.019 321.237 196.729 319.144 196.157 317.119C195.1 313.449 193.13 310.106 190.431 307.404C186.883 303.852 184.887 299.039 184.881 294.019V269.871C184.881 267.379 185.371 264.911 186.325 262.609C187.279 260.306 188.677 258.214 190.439 256.452L212.944 233.947C213.98 232.912 214.801 231.682 215.361 230.329C215.922 228.975 216.209 227.525 216.208 226.06V213.698C216.205 213.583 216.226 213.468 216.268 213.361C216.31 213.254 216.373 213.156 216.453 213.074C216.534 212.991 216.63 212.926 216.736 212.881C216.842 212.837 216.956 212.814 217.071 212.814H239.239C239.354 212.814 239.468 212.837 239.574 212.881C239.68 212.926 239.776 212.991 239.857 213.074C239.937 213.156 240 213.254 240.042 213.361C240.084 213.468 240.105 213.583 240.102 213.698V226.043C240.101 227.508 240.39 228.959 240.952 230.313C241.514 231.666 242.337 232.895 243.375 233.93L263.818 254.348L265.91 256.443C269.466 260.007 271.465 264.836 271.468 269.871V294.019C271.467 296.509 270.976 298.975 270.023 301.276C269.746 301.945 269.429 302.598 269.075 303.23C268.222 304.773 267.157 306.188 265.91 307.434C262.892 310.461 260.798 314.283 259.873 318.456C259.756 318.973 259.657 319.491 259.584 320.017C259.406 321.116 259.311 322.227 259.299 323.341Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.593 192.154H216.752C214.568 192.154 212.798 193.925 212.798 196.108V208.859C212.798 211.043 214.568 212.814 216.752 212.814H239.593C241.777 212.814 243.547 211.043 243.547 208.859V196.108C243.547 193.925 241.777 192.154 239.593 192.154Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.17 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.477 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.682 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.114 362.512V396.237C271.115 396.922 271.075 397.606 270.994 398.285C270.535 402.1 268.81 405.65 266.095 408.367L252.728 421.735C252.647 421.819 252.549 421.885 252.442 421.93C252.334 421.975 252.219 421.998 252.102 421.998H204.238C204.121 421.998 204.006 421.975 203.898 421.93C203.791 421.885 203.694 421.819 203.613 421.735L190.245 408.367C187.031 405.148 185.223 400.786 185.217 396.237V362.775C185.217 360.44 185.676 358.127 186.57 355.97C187.464 353.812 188.774 351.852 190.426 350.201C192.522 348.106 194.183 345.619 195.316 342.881C196.449 340.144 197.031 337.209 197.028 334.247V323.341C197.028 322.218 196.943 321.097 196.774 319.986H259.549C259.38 321.097 259.295 322.218 259.295 323.341V334.251C259.291 337.214 259.873 340.148 261.006 342.886C262.139 345.624 263.801 348.111 265.897 350.206L266.082 350.391C269.3 353.605 271.11 357.965 271.114 362.512Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.871 269.871V294.019C360.87 296.509 360.379 298.975 359.426 301.276C358.465 303.576 357.067 305.668 355.308 307.434C351.08 311.667 348.707 317.406 348.711 323.389V334.298C348.707 337.261 349.288 340.195 350.42 342.933C351.552 345.67 353.213 348.158 355.308 350.253L355.498 350.438C358.712 353.655 360.517 358.017 360.517 362.564V396.289C360.518 396.973 360.478 397.658 360.396 398.337C359.938 402.151 358.213 405.701 355.498 408.419L342.13 421.786C342.049 421.87 341.952 421.937 341.845 421.982C341.737 422.027 341.622 422.05 341.505 422.049H293.641C293.524 422.05 293.409 422.027 293.301 421.982C293.194 421.937 293.097 421.87 293.015 421.786L279.648 408.419C276.931 405.703 275.206 402.152 274.749 398.337C274.666 397.658 274.625 396.974 274.624 396.289V362.827C274.624 360.492 275.083 358.179 275.977 356.021C276.871 353.864 278.181 351.904 279.833 350.253C281.929 348.158 283.59 345.671 284.723 342.933C285.856 340.195 286.438 337.261 286.435 334.298V323.341C286.437 320.378 285.855 317.444 284.722 314.707C283.589 311.969 281.928 309.482 279.833 307.386C276.275 303.829 274.276 299.003 274.275 293.972V269.871C274.275 267.379 274.766 264.911 275.719 262.609C276.673 260.306 278.071 258.214 279.833 256.452L302.338 233.947C303.374 232.912 304.195 231.682 304.756 230.329C305.316 228.975 305.603 227.525 305.603 226.06V213.698C305.6 213.583 305.62 213.468 305.662 213.361C305.704 213.254 305.767 213.156 305.847 213.074C305.928 212.991 306.024 212.926 306.13 212.881C306.236 212.837 306.35 212.814 306.465 212.814H328.633C328.749 212.814 328.862 212.837 328.969 212.881C329.075 212.926 329.171 212.991 329.251 213.074C329.331 213.156 329.394 213.254 329.436 213.361C329.479 213.468 329.499 213.583 329.496 213.698V226.043C329.496 227.508 329.785 228.959 330.346 230.313C330.908 231.666 331.731 232.895 332.769 233.93L353.221 254.348L355.308 256.443C358.865 260.004 360.865 264.83 360.871 269.863V269.871Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.996 192.154H306.154C303.971 192.154 302.2 193.925 302.2 196.108V208.859C302.2 211.043 303.971 212.814 306.154 212.814H328.996C331.179 212.814 332.95 211.043 332.95 208.859V196.108C332.95 193.925 331.179 192.154 328.996 192.154Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.573 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.084 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.711 323.341V334.251C348.707 337.213 349.288 340.147 350.42 342.885C351.552 345.623 353.213 348.111 355.308 350.206L355.498 350.391C358.712 353.608 360.517 357.969 360.517 362.517V396.242C360.518 396.926 360.478 397.61 360.396 398.29C359.938 402.104 358.213 405.654 355.498 408.371L342.13 421.739C342.049 421.823 341.952 421.889 341.845 421.934C341.737 421.98 341.622 422.003 341.505 422.002H293.641C293.524 422.003 293.409 421.98 293.301 421.934C293.194 421.889 293.097 421.823 293.015 421.739L279.648 408.371C276.931 405.655 275.206 402.104 274.749 398.29C274.666 397.61 274.625 396.926 274.624 396.242V362.78C274.624 360.444 275.083 358.132 275.977 355.974C276.871 353.816 278.181 351.856 279.833 350.206C281.929 348.111 283.59 345.623 284.723 342.886C285.856 340.148 286.438 337.214 286.435 334.251V323.341C286.437 320.378 285.855 317.444 284.722 314.707C283.589 311.969 281.928 309.482 279.833 307.386C276.275 303.829 274.276 299.003 274.275 293.972V284.187H360.862V294.019C360.861 296.509 360.371 298.975 359.417 301.276C358.457 303.576 357.058 305.668 355.299 307.434C351.072 311.667 348.699 317.406 348.702 323.389L348.711 323.341Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.113 323.341V334.251C438.11 337.213 438.691 340.147 439.823 342.885C440.955 345.623 442.616 348.111 444.711 350.206L444.9 350.391C448.114 353.608 449.919 357.969 449.92 362.517V396.242C449.921 396.926 449.88 397.61 449.799 398.29C449.341 402.104 447.616 405.654 444.9 408.371L431.533 421.739C431.452 421.823 431.355 421.889 431.247 421.934C431.14 421.98 431.024 422.003 430.908 422.002H383.056C382.94 422.003 382.824 421.98 382.717 421.934C382.609 421.889 382.512 421.823 382.431 421.739L369.064 408.371C366.346 405.655 364.621 402.105 364.165 398.29C364.082 397.61 364.04 396.926 364.04 396.242V362.78C364.04 361.244 364.239 359.715 364.631 358.23C364.836 357.461 365.091 356.707 365.394 355.971C366.288 353.814 367.598 351.855 369.249 350.206C371.344 348.111 373.006 345.623 374.139 342.886C375.271 340.148 375.853 337.214 375.851 334.251V323.341C375.853 320.378 375.27 317.444 374.138 314.707C373.005 311.969 371.344 309.482 369.249 307.386C367.486 305.626 366.087 303.535 365.133 301.233C364.18 298.931 363.689 296.463 363.691 293.972V269.871C363.689 267.376 364.18 264.904 365.136 262.598C366.091 260.293 367.492 258.198 369.258 256.435L391.762 233.93C392.798 232.894 393.62 231.665 394.18 230.311C394.74 228.958 395.028 227.508 395.027 226.043V213.698C395.024 213.583 395.044 213.468 395.086 213.361C395.128 213.254 395.191 213.156 395.272 213.074C395.352 212.991 395.448 212.926 395.554 212.881C395.66 212.837 395.774 212.814 395.889 212.814H418.058C418.173 212.814 418.287 212.837 418.393 212.881C418.499 212.926 418.595 212.991 418.675 213.074C418.756 213.156 418.819 213.254 418.861 213.361C418.903 213.468 418.923 213.583 418.92 213.698V226.043C418.92 227.508 419.209 228.959 419.77 230.313C420.332 231.666 421.155 232.895 422.193 233.93L442.624 254.348L444.711 256.443C448.268 260.004 450.268 264.83 450.273 269.863V294.01C450.27 296.501 449.78 298.966 448.829 301.268C447.868 303.568 446.469 305.659 444.711 307.425C440.483 311.658 438.11 317.397 438.113 323.38V323.341Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.398 192.154H395.557C393.373 192.154 391.603 193.925 391.603 196.108V208.859C391.603 211.043 393.373 212.814 395.557 212.814H418.398C420.582 212.814 422.352 211.043 422.352 208.859V196.108C422.352 193.925 420.582 192.154 418.398 192.154Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.975 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.283 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.487 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92 362.512V396.237C449.921 396.922 449.881 397.606 449.799 398.285C449.341 402.1 447.616 405.65 444.9 408.367L431.533 421.735C431.452 421.818 431.355 421.885 431.247 421.93C431.14 421.975 431.024 421.998 430.908 421.998H383.056C382.94 421.998 382.824 421.975 382.717 421.93C382.609 421.885 382.512 421.818 382.431 421.735L369.064 408.367C366.347 405.651 364.621 402.1 364.165 398.285C364.082 397.606 364.04 396.922 364.04 396.237V362.775C364.04 361.24 364.239 359.711 364.631 358.226C364.836 357.457 365.091 356.702 365.394 355.967C366.288 353.81 367.598 351.851 369.249 350.201C371.344 348.106 373.006 345.619 374.139 342.881C375.271 340.144 375.853 337.209 375.851 334.247V323.341C375.853 320.379 375.27 317.445 374.138 314.707C373.005 311.969 371.344 309.482 369.249 307.387C366.735 304.869 364.976 301.698 364.174 298.232H449.79C449.555 299.263 449.235 300.272 448.833 301.25C447.872 303.55 446.474 305.642 444.715 307.408C440.487 311.641 438.114 317.38 438.117 323.363V334.272C438.114 337.235 438.695 340.169 439.827 342.907C440.959 345.645 442.62 348.132 444.715 350.227L444.905 350.413C448.111 353.624 449.914 357.975 449.92 362.512Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.511 323.341V334.251C527.508 340.233 529.881 345.972 534.109 350.206L534.299 350.391C537.512 353.608 539.318 357.969 539.318 362.517V396.242C539.319 396.926 539.279 397.61 539.197 398.29C538.739 402.104 537.014 405.654 534.299 408.371L520.931 421.739C520.85 421.823 520.753 421.889 520.646 421.934C520.538 421.98 520.423 422.003 520.306 422.002H472.442C472.325 422.003 472.21 421.98 472.102 421.934C471.995 421.889 471.897 421.823 471.816 421.739L458.449 408.371C455.732 405.655 454.007 402.105 453.55 398.29C453.465 397.61 453.423 396.926 453.425 396.242V362.78C453.426 361.244 453.624 359.715 454.016 358.23C454.221 357.461 454.476 356.707 454.779 355.971C455.673 353.814 456.983 351.855 458.634 350.206C460.73 348.111 462.391 345.623 463.524 342.886C464.657 340.148 465.239 337.214 465.236 334.251V323.341C465.238 320.378 464.656 317.444 463.523 314.707C462.39 311.969 460.729 309.482 458.634 307.386C455.076 303.829 453.077 299.003 453.076 293.972V269.871C453.076 267.379 453.567 264.911 454.52 262.609C455.474 260.306 456.872 258.214 458.634 256.452L481.139 233.947C482.175 232.912 482.996 231.682 483.556 230.329C484.117 228.975 484.404 227.525 484.403 226.06V213.698C484.401 213.583 484.421 213.468 484.463 213.361C484.505 213.254 484.568 213.156 484.648 213.074C484.729 212.991 484.825 212.926 484.931 212.881C485.037 212.837 485.151 212.814 485.266 212.814H507.434C507.549 212.814 507.663 212.837 507.769 212.881C507.875 212.926 507.972 212.991 508.052 213.074C508.132 213.156 508.195 213.254 508.237 213.361C508.279 213.468 508.3 213.583 508.297 213.698V226.043C508.296 227.508 508.585 228.959 509.147 230.313C509.709 231.666 510.532 232.895 511.57 233.93L532.026 254.348L534.113 256.443C537.67 260.004 539.67 264.83 539.676 269.863V294.01C539.675 296.501 539.184 298.967 538.231 301.268C537.271 303.568 535.872 305.659 534.113 307.425C529.886 311.658 527.513 317.397 527.516 323.38L527.511 323.341Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.801 192.154H484.96C482.776 192.154 481.006 193.925 481.006 196.108V208.859C481.006 211.043 482.776 212.814 484.96 212.814H507.801C509.985 212.814 511.755 211.043 511.755 208.859V196.108C511.755 193.925 509.985 192.154 507.801 192.154Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.378 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.685 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.89 192.154V212.809",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.322 362.512V396.237C539.323 396.922 539.283 397.606 539.202 398.285C538.743 402.1 537.018 405.65 534.303 408.367L520.935 421.735C520.854 421.818 520.757 421.885 520.65 421.93C520.542 421.975 520.427 421.998 520.31 421.998H472.446C472.329 421.998 472.214 421.975 472.106 421.93C471.999 421.885 471.902 421.818 471.821 421.735L458.453 408.367C455.736 405.651 454.011 402.1 453.555 398.285C453.47 397.606 453.428 396.922 453.43 396.237V362.775C453.43 361.24 453.628 359.711 454.02 358.226C454.225 357.457 454.48 356.702 454.784 355.967C455.677 353.81 456.987 351.851 458.639 350.201C460.151 348.687 461.44 346.965 462.468 345.087H530.275C531.302 346.965 532.591 348.687 534.105 350.201L534.294 350.387C537.511 353.602 539.32 357.964 539.322 362.512Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89 396.207C114.984 396.207 117.492 393.699 117.492 390.606C117.492 387.512 114.984 385.004 111.89 385.004C108.797 385.004 106.289 387.512 106.289 390.606C106.289 393.699 108.797 396.207 111.89 396.207Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.673 379.67C143.767 379.67 146.275 377.162 146.275 374.069C146.275 370.975 143.767 368.467 140.673 368.467C137.58 368.467 135.072 370.975 135.072 374.069C135.072 377.162 137.58 379.67 140.673 379.67Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.637 407.414C159.73 407.414 162.238 404.906 162.238 401.813C162.238 398.719 159.73 396.211 156.637 396.211C153.543 396.211 151.035 398.719 151.035 401.813C151.035 404.906 153.543 407.414 156.637 407.414Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.514 368.911C207.608 368.911 210.115 366.404 210.115 363.31C210.115 360.216 207.608 357.709 204.514 357.709C201.42 357.709 198.913 360.216 198.913 363.31C198.913 366.404 201.42 368.911 204.514 368.911Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.17 407.414C231.264 407.414 233.772 404.906 233.772 401.813C233.772 398.719 231.264 396.211 228.17 396.211C225.077 396.211 222.569 398.719 222.569 401.813C222.569 404.906 225.077 407.414 228.17 407.414Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.711 383.538C247.805 383.538 250.313 381.03 250.313 377.937C250.313 374.843 247.805 372.335 244.711 372.335C241.618 372.335 239.11 374.843 239.11 377.937C239.11 381.03 241.618 383.538 244.711 383.538Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.569 340.305C225.662 340.305 228.17 337.797 228.17 334.704C228.17 331.61 225.662 329.102 222.569 329.102C219.475 329.102 216.967 331.61 216.967 334.704C216.967 337.797 219.475 340.305 222.569 340.305Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.656 356.29C249.75 356.29 252.258 353.782 252.258 350.689C252.258 347.595 249.75 345.087 246.656 345.087C243.563 345.087 241.055 347.595 241.055 350.689C241.055 353.782 243.563 356.29 246.656 356.29Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.279 307.141C307.372 307.141 309.88 304.633 309.88 301.539C309.88 298.446 307.372 295.938 304.279 295.938C301.185 295.938 298.677 298.446 298.677 301.539C298.677 304.633 301.185 307.141 304.279 307.141Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.802 334.704C310.895 334.704 313.403 332.196 313.403 329.102C313.403 326.009 310.895 323.501 307.802 323.501C304.708 323.501 302.2 326.009 302.2 329.102C302.2 332.196 304.708 334.704 307.802 334.704Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.95 318.227C336.043 318.227 338.551 315.719 338.551 312.626C338.551 309.532 336.043 307.024 332.95 307.024C329.856 307.024 327.348 309.532 327.348 312.626C327.348 315.719 329.856 318.227 332.95 318.227Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.573 365.733C320.666 365.733 323.174 363.226 323.174 360.132C323.174 357.038 320.666 354.531 317.573 354.531C314.479 354.531 311.971 357.038 311.971 360.132C311.971 363.226 314.479 365.733 317.573 365.733Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.072 370.998C296.165 370.998 298.673 368.491 298.673 365.397C298.673 362.303 296.165 359.796 293.072 359.796C289.978 359.796 287.47 362.303 287.47 365.397C287.47 368.491 289.978 370.998 293.072 370.998Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.686 407.414C333.779 407.414 336.287 404.906 336.287 401.813C336.287 398.719 333.779 396.211 330.686 396.211C327.592 396.211 325.084 398.719 325.084 401.813C325.084 404.906 327.592 407.414 330.686 407.414Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.374 389.144C382.467 389.144 384.975 386.636 384.975 383.542C384.975 380.449 382.467 377.941 379.374 377.941C376.28 377.941 373.772 380.449 373.772 383.542C373.772 386.636 376.28 389.144 379.374 389.144Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.581 407.414C415.675 407.414 418.183 404.906 418.183 401.813C418.183 398.719 415.675 396.211 412.581 396.211C409.488 396.211 406.98 398.719 406.98 401.813C406.98 404.906 409.488 407.414 412.581 407.414Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.487 389.144C417.581 389.144 420.089 386.636 420.089 383.542C420.089 380.449 417.581 377.941 414.487 377.941C411.394 377.941 408.886 380.449 408.886 383.542C408.886 386.636 411.394 389.144 414.487 389.144Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.089 354.526C423.182 354.526 425.69 352.018 425.69 348.925C425.69 345.831 423.182 343.323 420.089 343.323C416.995 343.323 414.487 345.831 414.487 348.925C414.487 352.018 416.995 354.526 420.089 354.526Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.971 332.595C398.064 332.595 400.572 330.087 400.572 326.993C400.572 323.9 398.064 321.392 394.971 321.392C391.877 321.392 389.369 323.9 389.369 326.993C389.369 330.087 391.877 332.595 394.971 332.595Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.057 363.31C483.15 363.31 485.658 360.802 485.658 357.709C485.658 354.615 483.15 352.107 480.057 352.107C476.963 352.107 474.455 354.615 474.455 357.709C474.455 360.802 476.963 363.31 480.057 363.31Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.456 383.538C477.549 383.538 480.057 381.03 480.057 377.937C480.057 374.843 477.549 372.335 474.456 372.335C471.362 372.335 468.854 374.843 468.854 377.937C468.854 381.03 471.362 383.538 474.456 383.538Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.333 385.272C525.426 385.272 527.934 382.764 527.934 379.67C527.934 376.577 525.426 374.069 522.333 374.069C519.239 374.069 516.731 376.577 516.731 379.67C516.731 382.764 519.239 385.272 522.333 385.272Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.284 407.414C501.378 407.414 503.886 404.906 503.886 401.813C503.886 398.719 501.378 396.211 498.284 396.211C495.191 396.211 492.683 398.719 492.683 401.813C492.683 404.906 495.191 407.414 498.284 407.414Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.352 316.17C425.446 316.17 427.954 313.662 427.954 310.569C427.954 307.475 425.446 304.967 422.352 304.967C419.259 304.967 416.751 307.475 416.751 310.569C416.751 313.662 419.259 316.17 422.352 316.17Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.007 405.944V486.394C273.007 488.823 272.144 491.172 270.571 493.022L262.425 502.608C261.45 503.754 260.237 504.675 258.871 505.306C257.505 505.938 256.018 506.265 254.513 506.265H212.155C210.6 506.268 209.064 505.921 207.661 505.249C206.258 504.577 205.025 503.598 204.053 502.384L196.519 492.975C195.066 491.16 194.273 488.905 194.273 486.58V405.465C194.274 403.368 194.92 401.322 196.123 399.605L207.17 383.805L259.316 384.15L270.985 399.833C272.297 401.601 273.006 403.743 273.007 405.944Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.694 382.378V386.69C265.694 390.929 251.343 394.361 233.642 394.361C215.941 394.361 201.586 390.912 201.586 386.69V382.378H207.123C212.888 380.347 222.62 379.01 233.659 379.01C244.698 379.01 254.431 380.347 260.196 382.378H265.694Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.638 390.054C251.342 390.054 265.694 386.617 265.694 382.378C265.694 378.139 251.342 374.703 233.638 374.703C215.934 374.703 201.582 378.139 201.582 382.378C201.582 386.617 215.934 390.054 233.638 390.054Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.856 385.341L239.213 386.526C235.531 386.902 232.047 385.591 232.047 383.823V380.938C232.047 379.071 235.928 377.738 239.718 378.295L251.361 379.994C253.827 380.356 255.509 381.425 255.509 382.637C255.509 383.939 253.573 385.065 250.856 385.341Z",
    fill: "#050D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.942 405.944V486.394C356.942 488.823 356.078 491.172 354.506 493.022L346.36 502.608C345.386 503.754 344.174 504.675 342.808 505.306C341.443 505.937 339.956 506.264 338.452 506.265H296.094C294.538 506.269 293.001 505.922 291.598 505.25C290.194 504.578 288.96 503.598 287.988 502.384L280.459 492.975C279.304 491.543 278.559 489.825 278.303 488.003C278.235 487.532 278.202 487.056 278.203 486.58V405.465C278.203 403.369 278.847 401.323 280.049 399.605L291.092 383.805L343.243 384.15L354.916 399.833C356.229 401.6 356.94 403.742 356.942 405.944Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.633 382.378V386.69C349.633 390.929 335.283 394.361 317.577 394.361C299.872 394.361 285.525 390.912 285.525 386.69V382.378H291.041C296.806 380.347 306.538 379.01 317.577 379.01C328.616 379.01 338.349 380.347 344.114 382.378H349.633Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 390.054C335.281 390.054 349.633 386.617 349.633 382.378C349.633 378.139 335.281 374.703 317.577 374.703C299.873 374.703 285.521 378.139 285.521 382.378C285.521 386.617 299.873 390.054 317.577 390.054Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.795 385.341L323.153 386.526C319.47 386.902 315.99 385.591 315.99 383.823V380.938C315.99 379.071 319.871 377.738 323.657 378.295L335.3 379.994C337.771 380.356 339.448 381.425 339.448 382.637C339.444 383.939 337.508 385.065 334.795 385.341Z",
    fill: "#050D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.881 405.944V486.394C440.879 488.822 440.016 491.171 438.445 493.022L430.295 502.608C429.32 503.755 428.108 504.676 426.741 505.307C425.375 505.939 423.888 506.265 422.383 506.265H380.038C378.481 506.268 376.944 505.92 375.54 505.249C374.136 504.577 372.901 503.598 371.927 502.384L364.394 492.975C362.943 491.159 362.152 488.904 362.151 486.58V405.465C362.152 403.368 362.798 401.322 364.001 399.605L375.044 383.805L427.191 384.15L438.859 399.833C440.172 401.6 440.881 403.743 440.881 405.944Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.568 382.378V386.69C433.568 390.929 419.218 394.361 401.516 394.361C383.815 394.361 369.46 390.912 369.46 386.69V382.378H374.98C380.745 380.347 390.477 379.01 401.516 379.01C412.555 379.01 422.288 380.347 428.053 382.378H433.568Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.512 390.054C419.216 390.054 433.568 386.617 433.568 382.378C433.568 378.139 419.216 374.703 401.512 374.703C383.808 374.703 369.456 378.139 369.456 382.378C369.456 386.617 383.808 390.054 401.512 390.054Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73 385.341L407.088 386.526C403.405 386.902 399.921 385.591 399.921 383.823V380.938C399.921 379.071 403.802 377.738 407.588 378.295L419.23 379.994C421.701 380.356 423.383 381.425 423.383 382.637C423.383 383.939 421.434 385.065 418.73 385.341Z",
    fill: "#050D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.63 268.22L415.561 274.722L414.414 381.792C414.414 383.517 412.504 384.651 410.304 384.676C408.105 384.702 406.316 383.495 406.458 381.882L407.786 278.603L372.276 318.563L367.235 324.234C366.561 324.992 365.623 325.465 364.613 325.555C363.603 325.646 362.596 325.347 361.798 324.721L355.817 320.025L343.997 310.737L342.01 309.176L339.211 312.591L306.642 352.336L301.23 358.942C300.569 359.749 299.617 360.263 298.58 360.375C297.543 360.488 296.503 360.188 295.685 359.541L289.915 354.983L277.41 345.173L275.896 343.983L274.357 345.833L245.095 381.085C242.581 383.81 234.401 384.733 235.785 379.838L269.217 339.555L272.236 335.915C272.898 335.116 273.847 334.607 274.88 334.497C275.913 334.387 276.948 334.686 277.764 335.329L283.481 339.818L294.822 348.731L297.547 350.887L298.988 349.132L333.411 307.132L338.336 301.121C338.997 300.317 339.946 299.804 340.98 299.691C342.015 299.577 343.053 299.872 343.872 300.513L349.112 304.631L360.448 313.544L363.781 316.157L365.713 314.001L405.195 269.552L408.666 265.65C409.199 265.05 409.901 264.625 410.679 264.431C411.458 264.237 412.277 264.283 413.029 264.562C413.781 264.842 414.431 265.343 414.894 265.999C415.356 266.654 415.61 267.435 415.621 268.237L415.63 268.22Z",
    fill: "#F9F8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.007 430.764V485.795C264.383 481.914 256.19 476.955 247.475 473.182C232.833 466.843 216.932 463.946 200.995 464.713C198.753 464.825 196.515 465.007 194.273 465.188V425.771C205.541 423.596 217.02 422.699 228.489 423.097C237.839 423.413 247.138 424.61 256.263 426.672C261.848 427.931 267.415 429.522 273.007 430.764Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.942 412.472V480.733C332.976 487.102 308.819 496.256 285.12 490.146C282.813 489.55 280.54 488.831 278.311 487.99C278.243 487.519 278.21 487.043 278.212 486.567V431.803C282.5 432.599 286.862 432.931 291.222 432.795C309.302 432.023 325.149 420.971 342.436 415.629C347.176 414.179 352.028 413.123 356.942 412.472Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.881 421.692V478.667C416.47 473.098 391.129 472.991 366.67 478.352C365.161 478.683 363.653 479.037 362.147 479.413V411.894C380.788 410.312 400.024 413.55 418.553 417.276C425.953 418.764 433.404 420.333 440.881 421.692Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.945 445.184C269.632 445.356 271.32 445.513 273.007 445.654V467.214C246.747 460.824 221.077 449.513 194.273 451.005V439.035C200.93 438.617 207.607 438.617 214.264 439.035C232.262 440.078 250.024 443.368 267.945 445.184Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.315 446.201C318.151 445.076 337.421 439.595 356.959 435.852V471.048C330.962 473.264 304.856 473.933 279.428 468.654L278.229 468.4V446.038C284.915 446.492 291.622 446.547 298.315 446.201Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.881 436.033V462.268L384.035 468.353C376.761 469.133 369.46 469.905 362.147 470.586V434.904C366.64 434.128 371.151 433.468 375.691 433.002C397.39 430.781 419.213 433.037 440.881 436.033Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.486 339.822L277.41 345.173L275.896 343.983L274.357 345.833C273.141 344.341 270.989 341.711 269.221 339.555L272.24 335.915C272.902 335.117 273.851 334.609 274.882 334.499C275.914 334.39 276.948 334.687 277.764 335.329L283.486 339.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.659 352.336L301.247 358.942C300.586 359.749 299.634 360.263 298.597 360.375C297.56 360.488 296.52 360.188 295.702 359.541L289.915 354.983L294.848 348.731L297.573 350.887L299.014 349.132L306.659 352.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 304.618L344.015 310.737L342.027 309.176L339.228 312.591L333.42 307.119L338.344 301.108C339.005 300.304 339.954 299.791 340.989 299.678C342.023 299.564 343.061 299.859 343.881 300.5L349.12 304.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.276 318.563L367.235 324.234C366.561 324.992 365.623 325.465 364.613 325.555C363.603 325.646 362.596 325.347 361.798 324.721L355.817 320.025L360.439 313.531L363.773 316.144L365.704 313.988L372.276 318.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.63 268.22L415.561 274.722L407.799 278.603L405.212 269.522L408.683 265.62C409.216 265.02 409.918 264.595 410.697 264.401C411.475 264.207 412.294 264.253 413.046 264.532C413.799 264.812 414.449 265.313 414.911 265.968C415.374 266.624 415.627 267.404 415.639 268.207L415.63 268.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.693 203.465C444.693 203.465 462.718 220.584 471.575 246.301C480.432 272.019 476.75 296.602 476.75 296.602C456.224 303.669 441.623 285.39 432.766 259.66C423.909 233.93 424.547 210.399 444.693 203.465Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.76 296.614C488.095 292.711 490.105 268.697 481.249 242.977C472.393 217.258 456.025 199.572 444.689 203.475C433.354 207.378 431.344 231.392 440.2 257.111C449.056 282.831 465.424 300.517 476.76 296.614Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.251 242.964L477.202 244.357",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.629 255.572L440.58 256.969",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.025 203.823L448.19 213.012",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.641 286.921L476.806 296.106",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.529 277.642L481.432 272.131",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.403 227.798L435.302 222.287",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.059 212.387L463.434 219.868",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.397 280.061L457.772 287.547",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.278 290.104L478.824 282.109",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.007 217.82L438.553 209.825",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.8 226.151L471.234 230.894",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.597 269.035L448.031 273.778",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.617 295.188L466.284 286.18",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.547 213.749L454.214 204.746",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.839 261.51L480.876 259.212",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.955 240.721L435.996 238.423",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.579 252.466C475.069 251.953 475.334 248.795 474.169 245.413C473.004 242.031 470.852 239.705 469.361 240.218C467.871 240.731 467.606 243.889 468.771 247.271C469.935 250.654 472.088 252.979 473.579 252.466Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.775 259.63C454.266 259.117 454.53 255.959 453.366 252.577C452.201 249.195 450.049 246.869 448.558 247.382C447.068 247.895 446.803 251.053 447.968 254.435C449.132 257.818 451.285 260.143 452.775 259.63Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.047 232.446C456.538 231.933 456.802 228.775 455.638 225.393C454.473 222.011 452.321 219.685 450.83 220.198C449.34 220.712 449.075 223.869 450.24 227.252C451.404 230.634 453.557 232.959 455.047 232.446Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.54 260.018C466.996 259.172 467.432 253.968 465.513 248.395C463.594 242.822 460.047 238.99 457.59 239.836C455.134 240.682 454.698 245.885 456.617 251.458C458.536 257.032 462.083 260.864 464.54 260.018Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.304 279.655C472.794 279.142 473.059 275.984 471.894 272.602C470.73 269.22 468.577 266.894 467.087 267.408C465.596 267.921 465.332 271.079 466.496 274.461C467.661 277.843 469.813 280.169 471.304 279.655Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.281 455.252C130.281 455.252 137.288 431.407 156.154 411.791C175.019 392.175 198.55 384.219 198.55 384.219C214.203 399.26 204.587 420.6 185.739 440.212C166.891 459.823 145.65 470.017 130.281 455.252Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.061 434.724C198.906 415.107 207.174 392.472 198.528 384.167C189.883 375.861 167.598 385.031 148.753 404.647C129.909 424.264 121.641 446.899 130.286 455.204C138.932 463.51 161.217 454.34 180.061 434.724Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75 404.693L151.837 407.664",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.679 431.532L179.767 434.498",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.449 454.787L137.181 447.78",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.336 391.412L198.072 384.405",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.201 384.176L174.623 391.231",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.894 447.965L151.32 455.015",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.384 433.942L136.327 431.088",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19 408.104L199.133 405.25",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.775 381.386L184.696 388.993",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.826 450.199L138.742 457.81",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.189 418.996L142.579 419.117",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.938 420.079L191.328 420.195",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.444 392.999L194.036 398.298",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.481 440.898L127.077 446.193",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.161 392.154L163.381 397.617",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.14 441.574L165.356 447.042",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.272 413.79C160.75 411.21 161.838 408.234 160.701 407.142C159.564 406.049 156.633 407.255 154.155 409.835C151.677 412.414 150.59 415.391 151.727 416.483C152.864 417.575 155.794 416.37 158.272 413.79Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.143 429.032C176.621 426.453 177.708 423.476 176.571 422.384C175.434 421.292 172.504 422.498 170.025 425.077C167.547 427.657 166.46 430.633 167.597 431.726C168.734 432.818 171.665 431.612 174.143 429.032Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.914 439.411C151.393 436.832 152.48 433.855 151.343 432.763C150.206 431.671 147.275 432.877 144.797 435.456C142.319 438.036 141.232 441.012 142.369 442.105C143.506 443.197 146.436 441.991 148.914 439.411Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.544 422.69C171.627 418.44 173.418 413.535 171.545 411.735C169.671 409.935 164.842 411.922 160.758 416.172C156.675 420.423 154.884 425.328 156.758 427.128C158.631 428.928 163.46 426.941 167.544 422.69Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.501 403.406C185.979 400.827 187.066 397.85 185.929 396.758C184.792 395.666 181.861 396.872 179.383 399.451C176.905 402.031 175.818 405.007 176.955 406.1C178.092 407.192 181.023 405.986 183.501 403.406Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.984 259.554L184.919 249.238C175.561 244.173 163.87 247.654 158.806 257.011C153.743 266.368 157.224 278.059 166.582 283.123L185.647 293.44C195.005 298.504 206.696 295.024 211.76 285.666C216.823 276.309 213.342 264.619 203.984 259.554Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.698 257.224L136.965 263.692C136.638 263.79 136.289 263.788 135.963 263.687C135.637 263.587 135.348 263.391 135.133 263.126C134.918 262.861 134.786 262.538 134.754 262.198C134.723 261.859 134.793 261.517 134.956 261.217L149.186 234.948C149.348 234.645 149.597 234.398 149.901 234.238C150.205 234.078 150.549 234.013 150.891 234.05C151.232 234.087 151.554 234.225 151.817 234.446C152.079 234.668 152.27 234.962 152.364 235.293L158.698 257.224Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.81 257.008L138.354 254.926",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.408 241.89L158.81 257.008",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.763 285.666L233.496 279.198C233.824 279.099 234.174 279.099 234.502 279.199C234.829 279.3 235.12 279.495 235.336 279.761C235.552 280.027 235.684 280.352 235.715 280.693C235.746 281.034 235.674 281.377 235.509 281.678L221.279 307.943C221.117 308.244 220.868 308.49 220.565 308.649C220.262 308.808 219.919 308.874 219.578 308.837C219.238 308.8 218.916 308.664 218.654 308.444C218.392 308.224 218.201 307.931 218.106 307.602L211.763 285.666Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.651 285.873L232.103 287.96",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.048 300.996L211.651 285.873",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.81 257.008L206.226 260.971",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.444 276.434L213.949 278.802",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.259 291.061L206.955 291.466",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.275 400.232L457.959 420.25C453.877 430.077 458.532 441.352 468.358 445.433C478.183 449.515 489.457 444.858 493.539 435.032L501.856 415.014C505.938 405.188 501.282 393.913 491.457 389.831C481.632 385.749 470.358 390.406 466.275 400.232Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.617 445.593L477.271 466.554C477.402 466.87 477.436 467.218 477.369 467.553C477.302 467.888 477.137 468.195 476.895 468.436C476.653 468.677 476.345 468.841 476.009 468.907C475.674 468.973 475.327 468.937 475.012 468.805L447.414 457.344C447.098 457.214 446.827 456.993 446.637 456.709C446.447 456.425 446.345 456.09 446.345 455.748C446.345 455.406 446.447 455.072 446.637 454.788C446.827 454.504 447.098 454.283 447.414 454.153L468.617 445.593Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.393 445.499L468.406 466.059",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.719 460.375L468.393 445.499",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.501 389.903L482.847 368.942C482.717 368.626 482.683 368.28 482.75 367.945C482.817 367.611 482.982 367.304 483.223 367.063C483.464 366.822 483.772 366.658 484.106 366.592C484.44 366.526 484.787 366.56 485.102 366.691L512.699 378.148C513.017 378.277 513.289 378.498 513.481 378.783C513.672 379.067 513.774 379.403 513.774 379.746C513.774 380.089 513.672 380.424 513.481 380.708C513.289 380.993 513.017 381.214 512.699 381.343L491.501 389.903Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.717 389.993L491.704 369.433",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.39 375.121L491.717 389.993",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.393 445.499L467.496 397.927",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.65 442.89L484.447 388.424",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.979 419.695L497.758 394.094",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67041 351.24L9.70653 373.12L14.4197 398.661L18.7231 421.993H62.7539L67.0574 398.661L71.7705 373.12L75.8109 351.24H5.67041Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.43116 351.24H81.0458V344.514H0.43116V351.24Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4197 398.661L18.7231 421.993H62.7539L67.0574 398.661H14.4197Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70654 373.12L14.4197 398.661H67.0574L71.7705 373.12H9.70654Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05542 344.514C9.05542 344.514 13.3028 325.394 30.5512 325.54C47.7996 325.687 69.1186 344.514 69.1186 344.514H9.05542Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7036 290.302C23.7036 290.393 23.7036 290.483 23.7036 290.578L25.036 339.184H34.1432L35.5015 290.569C35.5438 289.781 35.4275 288.993 35.1595 288.251C34.8914 287.509 34.4771 286.828 33.941 286.249C33.405 285.67 32.7581 285.204 32.0387 284.88C31.3194 284.555 30.5423 284.379 29.7534 284.36C28.9645 284.342 28.1799 284.482 27.4462 284.772C26.7125 285.063 26.0445 285.497 25.482 286.051C24.9194 286.604 24.4736 287.265 24.1711 287.993C23.8686 288.722 23.7155 289.504 23.7209 290.293L23.7036 290.302Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7407 311.97C40.7407 312.061 40.7407 312.151 40.7407 312.246L41.4781 339.184H51.771L52.5127 312.246C52.555 311.458 52.4387 310.67 52.1707 309.928C51.9026 309.185 51.4883 308.505 50.9522 307.926C50.4162 307.347 49.7693 306.881 49.05 306.557C48.3306 306.232 47.5535 306.055 46.7646 306.037C45.9757 306.019 45.1912 306.159 44.4574 306.449C43.7237 306.739 43.0558 307.174 42.4932 307.727C41.9306 308.281 41.4848 308.941 41.1823 309.67C40.8798 310.399 40.7267 311.181 40.7321 311.97H40.7407Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.693 351.24L533.729 373.12L538.443 398.661L542.75 421.993H586.777L591.08 398.661L595.793 373.12L599.834 351.24H529.693Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.454 351.24H605.069V344.514H524.454V351.24Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.443 398.661L542.75 421.993H586.777L591.08 398.661H538.443Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.729 373.12L538.443 398.661H591.08L595.793 373.12H533.729Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.078 344.514C533.078 344.514 538.447 317.559 563 317.559C589.8 317.559 596.794 344.514 596.794 344.514H533.078Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.489 261.959C547.489 262.049 547.489 262.14 547.489 262.23L549.598 339.184H557.157L559.261 262.23C559.291 261.45 559.164 260.672 558.89 259.941C558.616 259.211 558.199 258.542 557.664 257.973C557.129 257.405 556.486 256.949 555.773 256.631C555.06 256.313 554.291 256.14 553.511 256.122C552.731 256.104 551.955 256.242 551.228 256.526C550.501 256.811 549.838 257.237 549.277 257.78C548.717 258.323 548.269 258.972 547.962 259.689C547.654 260.407 547.492 261.178 547.485 261.959H547.489Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.67 275.624C568.67 275.714 568.67 275.805 568.67 275.895L570.395 339.184H578.705L580.429 275.895C580.458 275.115 580.332 274.337 580.058 273.606C579.784 272.876 579.367 272.207 578.832 271.638C578.297 271.07 577.654 270.614 576.941 270.296C576.228 269.978 575.459 269.805 574.679 269.787C573.899 269.769 573.123 269.907 572.396 270.191C571.669 270.476 571.006 270.902 570.445 271.445C569.885 271.988 569.437 272.637 569.13 273.354C568.822 274.072 568.66 274.843 568.653 275.624H568.67Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9655 433.321L39.8524 506.265H104.965L110.359 485.433H134.33C135.757 485.434 137.147 484.981 138.3 484.14C139.453 483.299 140.308 482.113 140.743 480.754L145.917 464.571C146.254 463.516 146.338 462.396 146.161 461.303C145.984 460.21 145.551 459.174 144.898 458.279C144.245 457.384 143.39 456.656 142.403 456.155C141.415 455.653 140.324 455.391 139.216 455.391H118.16L123.874 433.321H20.9655ZM112.119 478.732L116.431 462.096H135.943C136.243 462.096 136.538 462.166 136.805 462.302C137.073 462.438 137.304 462.635 137.48 462.877C137.657 463.119 137.774 463.4 137.821 463.696C137.869 463.991 137.846 464.294 137.754 464.58L134.231 475.584C133.939 476.498 133.364 477.295 132.589 477.861C131.813 478.427 130.879 478.732 129.919 478.732H112.119Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9655 433.321C20.9655 434.266 21.9055 435.175 23.6433 436.029C25.1585 436.728 26.7347 437.287 28.3521 437.698C37.36 440.156 53.7244 441.799 72.4174 441.799C91.1103 441.799 107.479 440.156 116.487 437.698C118.103 437.288 119.678 436.729 121.191 436.029C122.916 435.167 123.874 434.266 123.874 433.321C123.874 428.643 100.834 424.848 72.4174 424.848C44.0007 424.848 20.9655 428.643 20.9655 433.321Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3521 437.698C37.36 440.156 53.7244 441.799 72.4173 441.799C91.1103 441.799 107.479 440.156 116.487 437.698C107.173 435.318 90.9162 433.735 72.4173 433.735C53.9185 433.735 37.6576 435.318 28.3521 437.698Z",
    fill: "#050D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3628 437.37V394.189",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2277 437.37V401.429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0968 437.37V361.111",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9617 437.37V347.437",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8308 437.37V356.855",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6957 437.37V374.332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5605 437.37V402.373",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4298 437.37V369.718",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2946 437.37V412.291",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9433 329.072C61.9433 329.072 85.7891 336.079 105.405 354.945C125.021 373.81 132.976 397.337 132.976 397.337C117.936 412.99 96.5953 403.374 76.9795 384.53C57.3638 365.686 47.1787 344.436 61.9433 329.072Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.985 397.272C141.29 388.626 132.12 366.341 112.504 347.497C92.8874 328.652 70.2522 320.384 61.9469 329.03C53.6416 337.675 62.8112 359.961 82.4278 378.805C102.044 397.65 124.679 405.917 132.985 397.272Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.494 347.541L109.527 350.628",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6597 375.47L82.693 378.558",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4047 329.236L69.4118 335.971",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78 390.127L132.787 396.858",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.015 375.992L125.961 373.413",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2263 352.685L62.1718 350.106",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.245 328.175L86.1039 335.118",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.083 390.981L111.942 397.923",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.805 388.566L128.199 383.482",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9927 342.616L59.3818 337.532",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.195 335.98L98.0742 341.37",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1126 384.728L96.9962 390.118",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.188 400.23L118.893 392.826",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2939 333.272L70.9987 325.868",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.038 361.952L119.574 362.167",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6169 363.927L70.1492 364.147",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.01 359.444C111.102 358.307 109.896 355.377 107.317 352.899C104.737 350.421 101.76 349.334 100.668 350.471C99.5759 351.608 100.782 354.538 103.361 357.016C105.941 359.494 108.917 360.581 110.01 359.444Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7671 375.309C95.8593 374.172 94.6536 371.241 92.074 368.763C89.4944 366.285 86.5178 365.198 85.4256 366.335C84.3334 367.472 85.5392 370.402 88.1188 372.88C90.6984 375.358 93.6749 376.445 94.7671 375.309Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3838 350.08C85.476 348.943 84.2702 346.013 81.6906 343.535C79.111 341.057 76.1345 339.969 75.0423 341.106C73.9501 342.243 75.1558 345.174 77.7354 347.652C80.315 350.13 83.2916 351.217 84.3838 350.08Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.412 370.284C107.212 368.41 105.225 363.581 100.975 359.498C96.724 355.414 91.819 353.623 90.019 355.497C88.2191 357.371 90.2057 362.2 94.4564 366.283C98.707 370.366 103.612 372.158 105.412 370.284Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.389 384.673C121.481 383.536 120.275 380.605 117.696 378.127C115.116 375.649 112.139 374.562 111.047 375.699C109.955 376.836 111.161 379.766 113.74 382.244C116.32 384.722 119.297 385.81 120.389 384.673Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_2867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 605.5,
    height: 505.955,
    fill: "white",
    transform: "translate(0 0.740479)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame22);
export default __webpack_public_path__ + "static/media/frame-22.8ca8f32c29391d53614d4aa44b132016.svg";
export { ForwardRef as ReactComponent };